export class Friend {
    jid = '';
    name = '';
    avatarUrl = '';
    createCollaborator = false;
    timeAssistantId = 0;
    isSelect = false;

    static of(o: any) {
        return Object.assign(new Friend(), o);

    }
}
